export let DuplexerChannel = /*#__PURE__*/function (DuplexerChannel) {
  DuplexerChannel["TASKS"] = "nownia-tasks";
  DuplexerChannel["ENRICHED_TASKS"] = "nownia-enriched-tasks";
  DuplexerChannel["ACTIONS"] = "nownia-actions";
  DuplexerChannel["ENRICHED_RECURRING_SCHEDULES"] = "recurring-schedules";
  return DuplexerChannel;
}({});
export let IndividualsDuplexerChannel = /*#__PURE__*/function (IndividualsDuplexerChannel) {
  IndividualsDuplexerChannel["DIGEST"] = "individuals-digest";
  IndividualsDuplexerChannel["ENRICHED_CONTEXT"] = "individuals-enriched-context";
  IndividualsDuplexerChannel["CONVERSATION"] = "individuals-conversation";
  IndividualsDuplexerChannel["RECIPIENT"] = "individuals-recipient";
  IndividualsDuplexerChannel["INSIGHT"] = "individuals-insight";
  IndividualsDuplexerChannel["ASSISTANT_CHAT"] = "individuals-assistant-chat";
  IndividualsDuplexerChannel["PULSE_IDENTITY"] = "individuals-pulse-identity";
  IndividualsDuplexerChannel["FILE_SYSTEM_KNOWLEDGE"] = "individuals-file-system-knowledge";
  IndividualsDuplexerChannel["INDIVIDUAL_TASK"] = "individuals-task";
  IndividualsDuplexerChannel["RECOMMENDATION"] = "individuals-recommendation";
  // Server→client UI commands (navigate the web client to a screen). One-shot,
  // conversation-scoped (entityId = conversationId). See ClientControlCommand.
  IndividualsDuplexerChannel["CLIENT_CONTROL"] = "individuals-client-control";
  // Lightweight "the VFS changed — refetch" signal: a backward-compatible
  // companion to FILE_SYSTEM_KNOWLEDGE (which still carries the full entity for
  // existing consumers such as the mobile knowledge screen). Payload is
  // entityId-only; subscribers refetch.
  IndividualsDuplexerChannel["FILE_SYSTEM_CHANGED"] = "individuals-file-system-changed";
  // Lightweight "an Orion dashboard changed — refetch" signal. Dashboards moved
  // off the VFS into the wix.symphony.v1.DashboardService, so a build/authoring
  // write no longer bumps the FileSystem (and no longer rides FILE_SYSTEM_CHANGED).
  // ManageDashboards publishes this after a mutating write; the dashboard surfaces
  // (web DashboardView / WorkspaceDashboard, native/RN home) refetch the rendered
  // dashboard on it. Payload is entityId-only (the metasite); subscribers refetch.
  IndividualsDuplexerChannel["DASHBOARD_CHANGED"] = "individuals-dashboard-changed";
  // Lightweight "an AgentTask (wix.symphony.v1.agent_task) changed — refetch" signal for the v2
  // task feed. The DIGEST channel only carries v1 IndividualTask digests — the harness does NOT digest
  // AgentTasks — so the v2 feed subscribes here instead. IMPORTANT: this is inert until a separate
  // harness change publishes CREATED/UPDATED/DELETED to it; until then the v2 feed relies on
  // focus / pull-to-refresh to stay fresh. Payload is entityId-only (the agent task id); subscribers refetch.
  IndividualsDuplexerChannel["AGENT_TASK"] = "individuals-agent-task";
  // Lightweight "a Goal (wix.symphony.v1.goal) changed — refetch" signal for the workspace goals feed,
  // mirroring AGENT_TASK. The harness consumes the Goal domain-events topic and publishes CREATED/
  // UPDATED/DELETED here; subscribers (the web/native Growth-and-Goals surfaces) refetch. Payload is
  // entityId-only (the goal id).
  IndividualsDuplexerChannel["GOAL"] = "individuals-goal";
  // Lightweight "an Agent (wix.symphony.v1.agent) changed — refetch" signal for the agent roster,
  // mirroring GOAL. The harness consumes the Agent domain-events topic and publishes CREATED/UPDATED/
  // DELETED here; subscribers (the web/native "your agents" + agents-island pill) refetch the roster so
  // an added / removed / renamed agent shows up live. Payload is entityId-only (the agent id).
  IndividualsDuplexerChannel["AGENT"] = "individuals-agent";
  // Lightweight "a Workspace (wix.symphony.v1.workspace) changed — refetch" signal, mirroring AGENT/GOAL.
  // The harness consumes the Workspace domain-events topic and publishes CREATED/UPDATED/DELETED here;
  // subscribers (the native home workspaces strip + the morning-brief "a new workspace created" state)
  // refetch their workspaces list so a newly created (or removed) workspace shows up live. Payload is
  // entityId-only (the workspace id).
  IndividualsDuplexerChannel["WORKSPACE"] = "individuals-workspace";
  return IndividualsDuplexerChannel;
}({});

/**
 * Navigate the client to a destination and open this thread in its chat. The destination is already
 * resolved to per-surface targets (`link`); each surface opens its own field — web `link.desktop`
 * (prepending its basePath + the conversation query), mobile `link.mobile`. See resolveNavLink.
 */

/**
 * Toggle the "Orion is working on this widget" indicator on the widget `slug`'s screen
 * — `editing` true while Orion is changing the widget, false once it's done. Doesn't
 * touch the widget itself, just the badge.
 */

/**
 * Ask the mobile app to raise a native OS permission dialog mid-conversation — the assistant drives
 * this during gradual onboarding once it has explained why it needs the access. Mobile-only: the web
 * client has no native permissions and simply ignores it. The grant outcome flows back through the
 * app's own side effects (contacts upload / push registration), not on this channel.
 */

/**
 * A server→client UI command published on the CLIENT_CONTROL channel. entityId is
 * the conversationId; `conversationId` here is carried so the client can attach the
 * command to the right thread.
 */
//# sourceMappingURL=Duplexer.js.map